import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Menu, X, LogOut } from "lucide-react";
import { navItemsForRole } from "./nav-items";
import { cn } from "@/lib/utils";
import { useAuth } from "@/contexts/AuthContext";

export function MobileNav({ role }) {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const items = navItemsForRole(role, user);
  const initials = ((user?.full_name || user?.email || "?").split(/[\s@.]/).filter(Boolean).slice(0, 2).map((s) => s[0].toUpperCase()).join("")) || "?";

  return (
    <div className="md:hidden">
      <button onClick={() => setOpen(true)} className="-ml-2 mr-2 rounded-md p-2 hover:bg-slate-100" aria-label="Open menu">
        <Menu className="h-5 w-5" />
      </button>
      {open && (
        <div className="fixed inset-0 z-50">
          <div className="absolute inset-0 bg-black/30" onClick={() => setOpen(false)} aria-hidden="true" />
          <div className="absolute left-0 top-0 flex h-full w-72 flex-col bg-white shadow-xl">
            <div className="flex items-center justify-between border-b border-slate-100 px-5 py-5">
              <div className="rounded-md bg-slate-950 px-3 py-1.5">
                <img src="/dolphin-logo.png" alt="Dolphin" className="h-8 w-auto object-contain" />
              </div>
              <button onClick={() => setOpen(false)} className="rounded-md p-1 text-slate-500 hover:bg-slate-100" aria-label="Close menu">
                <X className="h-5 w-5" />
              </button>
            </div>
            {user && (
              <div className="flex items-center gap-3 border-b border-slate-100 px-5 py-4">
                <div className="flex h-10 w-10 items-center justify-center rounded-full bg-gradient-to-br from-sky-500 to-blue-700 text-sm font-semibold text-white">{initials}</div>
                <div className="min-w-0">
                  <p className="truncate text-sm font-semibold">{user.full_name || "User"}</p>
                  <p className="truncate text-xs text-slate-500">{user.email}</p>
                </div>
              </div>
            )}
            <nav className="flex-1 space-y-1 overflow-y-auto px-3 py-4">
              <p className="mb-2 px-3 text-[10px] font-semibold uppercase tracking-[0.18em] text-slate-400">Menu</p>
              {items.map((item) => {
                const active = location.pathname === item.href || location.pathname.startsWith(item.href + "/");
                const Icon = item.icon;
                return (
                  <Link
                    key={item.href}
                    to={item.href}
                    onClick={() => setOpen(false)}
                    className={cn("flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium transition-colors", active ? "bg-slate-900 text-white" : "text-slate-600 hover:bg-slate-100")}
                  >
                    <Icon className={cn("h-4 w-4", active ? "text-sky-300" : "text-slate-400")} />
                    {item.label}
                  </Link>
                );
              })}
            </nav>
            <div className="border-t border-slate-100 px-3 py-4">
              <button onClick={() => { logout(); navigate("/login"); }} className="flex w-full items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium text-slate-600 hover:bg-slate-100">
                <LogOut className="h-4 w-4 text-slate-400" /> Sign Out
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
